export default {
  loadingInvoices: false,
  loadingInvoice: false,
  loadingInvoiceForm: false,
  loadingInvoiceHistory: false,
  loadingInvoiceOrderItems: false,
  invoices: [],
  invoice: null,
  invoiceForm: {
    logisticProviderId: null,
    deliveryMethodId: null,
    dueDate: null,
    invoiceFiles: null,
    ctesFiles: null,
  },
  invoiceMarkers: [],
  invoiceHistory: [],
  invoiceOrderItems: [],
  totalInvoiceOrderItems: 0,
  invoiceOrderItemsPagination: {
    limit: 10,
    page: 1,
  },
  totalInvoices: 0,
  filters: {
    invoiceNumber: null,
    state: null,
    logisticProviderId: null,
    created: null,
    due_date: null,
    limit: 10,
    page: 1,
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/invoice-audit/store/states.js